import React from "react"
import useSiteMetadata from "../../hooks/use-site-metadata"
import { createMarkup } from "../../../utils/markup-creator"
import { FooterType, LinkType } from "../../types"

type LayoutProps = {
  footer: FooterType
  [key: string]: any
}

const FooterMedshare = ({ footer }: LayoutProps) => {
  const { siteTitle, footerPhoneNumber } = useSiteMetadata()

  return (
    <footer className={`bg-medInk font-dmsans ${footer.advanced?.class || ``}`}>
      <div className="max-w-screen-xl mx-auto px-6 lg:px-12 pt-10 pb-28 md:pb-14">
        {footer.logo && (
          <img src={footer.logo} alt={siteTitle} className="h-8 w-auto" />
        )}

        {footer.links && footer.links.length > 0 && (
          <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2">
            {footer.links.map((link: LinkType, i: number) => (
              <a
                key={`footer-link-${i}`}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`text-medFootLink hover:text-white ${link.class || ``}`}
                style={{ fontSize: `14px`, lineHeight: `24px` }}
              >
                <span dangerouslySetInnerHTML={createMarkup(link.name)} />
              </a>
            ))}
          </div>
        )}

        <p className="mt-6 text-medFootLink" style={{ fontSize: `12px`, lineHeight: `16px` }}>
          © 2026 Unite Health Share Ministries<sup>™</sup> and WeShare<sup>®</sup>.
        </p>
        {footerPhoneNumber && (
          <p className="mt-4 text-medFootLink" style={{ fontSize: `12px`, lineHeight: `16px` }}>
            {footerPhoneNumber}
          </p>
        )}

        <div className="mt-5 space-y-5" style={{ maxWidth: `760px` }}>
          <p style={{ fontSize: `12px`, lineHeight: `20px`, color: `#8290a0` }}>
            <span className="font-bold" style={{ color: `#d3dde6` }}>WeShare<sup>®</sup> is not a reimbursement program.</span>{" "}
            WeShare<sup>®</sup> is not an insurance company nor is the membership offered through an insurance company. WeShare<sup>®</sup> membership is offered and administered by Unite Health Share Ministries<sup>™</sup> (UHSM), a nonprofit, religious healthcare sharing ministry that facilitates member-to-member sharing of medical expenses. WeShare<sup>®</sup> is connected through partnerships to provide resources, community, and healthcare for all WeShare<sup>®</sup> members.
          </p>
          <p style={{ fontSize: `12px`, lineHeight: `20px`, color: `#8290a0` }}>
            Members should never have to pay cash up-front for services in-network, with the only payment incurred at the time of service being the per member, per visit, consultation fee, as outlined in the Membership Guidelines. All Sharing Members are responsible for their own medical expenses, less amounts paid from shared dollars.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default FooterMedshare
